// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/assetClass.css
// module id = 907
// module chunks = 0